import {
  enumListAsRecordObject,
  lookupListAsRecordObject
} from '@utils/graph-utils';

export function toLookups(data: any) {
  const personDetailsList: Record<string, Record<string, string>> = {};

  personDetailsList['personType'] = enumListAsRecordObject(
    data?.PersonType?.enumValues
  );

  personDetailsList['phoneType'] = enumListAsRecordObject(
    data?.PhoneType?.enumValues
  );

  personDetailsList['genders'] = enumListAsRecordObject(
    data?.Gender?.enumValues
  );

  personDetailsList['maritalStatuses'] = enumListAsRecordObject(
    data?.MaritalStatus?.enumValues
  );

  personDetailsList['titles'] = lookupListAsRecordObject(data?.core?.getTitles);

  personDetailsList['countries'] = lookupListAsRecordObject(
    data?.core?.getCountries
  );

  personDetailsList['nationalities'] = lookupListAsRecordObject(
    data?.core?.getNationalities,
    false,
    'id',
    'title',
    'code',
    true
  );

  personDetailsList['occupationClass'] = lookupListAsRecordObject(
    data?.core?.getOccupationClass
  );

  personDetailsList['activePersons'] = lookupListAsRecordObject(
    data?.salesforce?.getAllPersons,
    false,
    'id',
    'fullName',
    'code'
  );

  personDetailsList['personRelation'] = enumListAsRecordObject(
    data?.PersonRelation?.enumValues,
    false,
    true
  );

  return personDetailsList;
}

export const filterPersonLovsById = (
  lovs: Record<string, string> | undefined | null,
  idToRemove: string
): Record<string, string> => {
  if (!lovs) return {};

  const updatedLovs: Record<string, string> = {};

  Object.entries(lovs).forEach(([id, label]) => {
    if (id !== idToRemove) {
      updatedLovs[id] = label;
    }
  });

  return updatedLovs;
};
